<template>
  <div class="table-toolbar">
    <label style="margin-bottom: 0" class="searcher">
      <input
        data-hj-allow
        type="text"
        @input="$emit('update-query', null, $event.target.value, 'name')"
        :value="query"
        :placeholder="placeholder"
        style="width: 360px; margin-bottom: 0"
      />
    </label>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'TableToolbar',
  props: {
    query: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Search by name',
    },
  },
};
</script>
